export const SkeletonTextSizeMap = {
  'text-xs': 10,
  'text-sm': 12,
  'text-base': 14,
  'text-lg': 16,
  'text-xl': 18,
  'text-2xl': 22,
  'text-3xl': 26,
  'text-4xl': 32,
  'text-5xl': 34,
  'text-6xl': 42,
};
